package com.eladfinish.bible.contest.ui.modifiers

import androidx.compose.foundation.background
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.alternateColorListView
import com.eladfinish.bible.contest.white
import dev.icerock.moko.resources.compose.colorResource

@Composable
fun Modifier.alternatingRowBackground(
    index: Int,
): Modifier = this.background(
    colorResource(
        resource = if (index % 2 == 0) {
            SharedRes.colors.white
        } else {
            SharedRes.colors.alternateColorListView
        }
    )
)
